import { SectionContainer } from "../atoms/containers/ContentContainers";
import { SectionOneContent } from "../molecules/section_one_content/SectionOneContent";

export function SectionOne() {
	return (
		<SectionContainer id="about" variant="alt">
			<SectionOneContent />
		</SectionContainer>
	);
}
